import React, { useEffect } from 'react';
import './assets/scss/Saas.scss';
import { BrowserRouter } from 'react-router-dom';
import { AllRoutes } from './routes/index';
import { logoutAllTabs } from './pages/account/Logout';

const App = () => {
    useEffect(() => {
        logoutAllTabs();
    }, []);

    return (
        <BrowserRouter>
            <AllRoutes />
        </BrowserRouter>
    );
};

export default App;
